import React, { MouseEventHandler } from 'react';
import { JourneyMenu, JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { AddStrongIcon, DeleteRegularIcon } from 'src/monet/icons';
import { useReactConstructor } from 'src/utils/react/constructor.hook';

export interface LibraryContentCardMenuProps
  extends Pick<JourneyMenuPropsInterface, 'placement' | 'openRef' | 'closeRef' | 'onOpen'> {
  renderMenuOrigin: (onClick: MouseEventHandler<HTMLElement>) => any;
  onClose: () => void;
  onDeleteClick: () => void;
  onTagsClick: () => void;
}

export const LibraryContentCardMenu = ({
  renderMenuOrigin,
  openRef,
  closeRef,
  onOpen,
  onClose,
  onDeleteClick,
  onTagsClick,
  placement,
}: LibraryContentCardMenuProps) => {
  const onMenuClicked: MouseEventHandler = () => {
    openRef.current();
  };

  useReactConstructor(() => {
    return () => {
      onClose();
    };
  });

  return (
    <JourneyMenu
      placement={placement}
      openRef={openRef}
      closeRef={closeRef}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={() => renderMenuOrigin(onMenuClicked)}
    >
      <JourneyMenu.Item onClick={onTagsClick}>
        <div className='flex items-center space-x-sm'>
          <AddStrongIcon />
          <span className='text-bedrock-p text-bedrock-black'>Tags</span>
        </div>
      </JourneyMenu.Item>
      <JourneyMenu.Item className='text-bedrock-p text-bedrock-black text-left flex gap-2' onClick={onDeleteClick}>
        <DeleteRegularIcon />
        <span>Delete content</span>
      </JourneyMenu.Item>
    </JourneyMenu>
  );
};
